import { render, staticRenderFns } from "./DonutWidget.vue?vue&type=template&id=08b6fa52&scoped=true"
import script from "./DonutWidget.vue?vue&type=script&lang=js"
export * from "./DonutWidget.vue?vue&type=script&lang=js"
import style0 from "./DonutWidget.vue?vue&type=style&index=0&id=08b6fa52&prod&lang=scss&scoped=true"
import style1 from "./DonutWidget.vue?vue&type=style&index=1&id=08b6fa52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6fa52",
  null
  
)

export default component.exports